import { useQuery } from "@tanstack/react-query";

import { useApiClient } from "../useApiClient";
import type { components } from "../schema";

export const INSTRUMENTS_QUERY_KEY = ["instruments"] as const;

export type InstrumentSortKey = components["schemas"]["InstrumentSortKey"];
export type SortOrder = components["schemas"]["SortOrder"];

export type ListInstrumentsQuery = {
  include_deleted?: boolean;
  sort_key?: InstrumentSortKey;
  sort_order?: SortOrder;
  limit?: number;
  offset?: number;
};

export function useInstruments(params: ListInstrumentsQuery = {}) {
  const client = useApiClient();
  return useQuery({
    queryKey: [...INSTRUMENTS_QUERY_KEY, params],
    queryFn: async () => {
      const { data, error } = await client.GET("/api/instruments", {
        params: { query: params },
      });
      if (error !== undefined) {
        throw new Error("Failed to list instruments");
      }
      return data;
    },
  });
}
